import React from 'react'
import spinnerSvg from './spinner.svg'

export type SpinnerProps = React.ImgHTMLAttributes<unknown>
export const Spinner = (props: SpinnerProps) => <img {...props} src={spinnerSvg} alt="loading" />
